import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'


function Header() {
  const handleCollapse = (e) => {
    const nav = document.getElementById("navbarCollapse");
    // Collapse the mobile navbar if open
    const navbar = document.getElementById("navbarCollapse");
    if (navbar && navbar.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(navbar, { toggle: true });
      bsCollapse.hide();
    }

    // Close the Tours dropdown if open
    const dropdownMenu = e.currentTarget.closest(".dropdown-menu");
    if (dropdownMenu && dropdownMenu.classList.contains("show")) {
      dropdownMenu.classList.remove("show");
      const parentDropdown = dropdownMenu.closest(".custom-dropdown");
      parentDropdown.classList.remove("show");
    }
  };


  return (
    <div>
      {/* ====== Reviews Topbar ====== */}
      <div
        className="container-fluid text-white px-3 py-2 border-bottom"
        style={{ backgroundColor: "#95472B" }}
      >
        <div className="row align-items-center">
          <div className="col-12 d-flex justify-content-center gap-3 flex-wrap">

            {/* TripAdvisor */}
            <div
              className="d-flex align-items-center flex-shrink-1"
              style={{ minWidth: "140px" }}
            >
              <img loading="lazy"
                src="https://redlionandcompany.com/Assets/TripadvisorLogo.png"
                alt="TripAdvisor"
                style={{ height: "24px", marginRight: "6px" }}
              />
              <div style={{ fontSize: "12px" }}>
                <span className="fw-bold">4.7/5</span>{" "}
                <span className="text-warning">★★★★★</span>
                <div>
                  Based on{" "}
                  <a
                    href="https://www.tripadvisor.com/Attraction_Review-g6940195-d14008647-Reviews-African_Travel_Tour-Arusha_National_Park_Arusha_Region.html"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white text-decoration-underline"
                  >
                    56+ reviews
                  </a>
                </div>
              </div>
            </div>

            {/* Google */}
            <div
              className="d-flex align-items-center flex-shrink-1 d-none d-md-flex"
              style={{ minWidth: "140px" }}
            >
              <i className="fab fa-google text-white fs-4 me-2"></i>
              <div style={{ fontSize: "12px" }}>
                <span className="fw-bold">4.9/5</span>{" "}
                <span className="text-warning">★★★★★</span>
                <div>
                  Based on{" "}
                  <a
                    href="https://www.google.com/search?sxsrf=AE3TifP7xlSIIOQUMPHZl4V5VrO77-Cnkw:1759250340482&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-Eyso6xoGtuRW9JmB2cps22l1JTrEXQqIqWobHBivbewwpu9fB1o9NGMsJCgYx2rMXkgI3uZdzjD2hwXe3jKlvSR3YzCTDIefx5WV4Nf-mBh4DmYGog%3D%3D&q=African+travel+tour+Reviews"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white text-decoration-underline"
                  >
                    13+ reviews
                  </a>
                </div>
              </div>
            </div>

            {/* Safaris Booking */}
            <div
              className="d-flex align-items-center flex-shrink-1"
              style={{ minWidth: "140px" }}
            >
              <img loading="lazy"
                src="https://pbs.twimg.com/profile_images/470860931837091840/XD8lQvLo_400x400.png"
                alt="Safaris Booking"
                style={{ height: "24px", width: "24px", borderRadius: "50%", marginRight: "6px" }}
              />
              <div style={{ fontSize: "12px" }}>
                <span className="fw-bold">4.9/5</span>{" "}
                <span className="text-warning">★★★★★</span>
                <div>
                  Based on{" "}
                  <a
                    href="https://www.safaribookings.com/reviews/p1826#80299"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white text-decoration-underline"
                  >
                    24+ reviews
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>



      {/* ====== Navbar ====== */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0 custom-navbar">
          <Link to="/" className="navbar-brand p-0">
            <img loading="lazy" className="img-fluid" src="https://africantraveltour.com/assets/img/aftt-logo.webp" alt="african travel tour logo" />

          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars" />
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0 align-items-lg-center">
              <Link to="/" className="nav-item nav-link fw-semibold" onClick={handleCollapse}>
                Home
              </Link>
              <Link to="/About" className="nav-item nav-link fw-semibold" onClick={handleCollapse}>
                About
              </Link>
              <Link to="/safaris_packages" className="nav-item nav-link fw-semibold" onClick={handleCollapse}>
                Safaris
              </Link>
              <Link to="/climbing_tours" className="nav-item nav-link fw-semibold" onClick={handleCollapse}>
                Climbing
              </Link>
               <Link to="/Gallery" className="nav-item nav-link fw-semibold" onClick={handleCollapse}>
                Gallery
              </Link>


              {/* Dropdown for Tours 
              <div className="nav-item dropdown custom-dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle fw-semibold"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Tours
                </Link>
                
                <ul className="dropdown-menu border-0 shadow-lg rounded-3 p-2">
                  <li>
                    <Link to="/packages" className="dropdown-item" onClick={handleCollapse}>
                      All tours
                    </Link>
                     <li>
                  </li>
                    <Link to="/Kenya_Safaris" className="dropdown-item" onClick={handleCollapse}>
                      Kenya Safaris
                    </Link>
                  </li>
                  <li>
                    <Link to="/HikingTours" className="dropdown-item" onClick={handleCollapse}>
                      Hiking Tours
                    </Link>
                  </li>
                  <li>
                    <Link to="/Tanzaniasafaris" className="dropdown-item" onClick={handleCollapse}>
                      Tanzania Safaris
                    </Link>
                  </li>
                 
                  <li>
                    <Link to="/Ethiopiasafaris" className="dropdown-item" onClick={handleCollapse}>
                      Ethiopia Safaris
                    </Link>
                  </li>
                </ul>
              </div>
              */}


            </div>

            <Link
              to="/contact"
              className="btn btn-primary rounded-pill ms-lg-4 py-2 px-4 shadow-sm"
              onClick={handleCollapse}
            >
              Contact
            </Link>
          </div>
        </nav>
      </div>

    </div>
  )
}

export default Header
